import React from 'react';
import { Box } from '@mui/material';

import PlaceObjectButton from './PlaceObjectButton';
import RedoButton from './RedoButton';
import ResetDocumentButton from './ResetDocument';
import ResetPageButton from './ResetPage';
import SaveAnnotations from './SaveAnnotations';
import UndoButton from './UndoButton';
import UploadObjectButton from './UploadObjectButton';

const buttonBorderSx = { width: '100%' } as const;

export default function ResetAndUndoButtons() {
  return (
    <Box sx={{ justifyContent: 'space-evenly', width: '100%', display: 'flex' }}>
      <Box sx={buttonBorderSx}>
        <SaveAnnotations />
      </Box>
      <Box sx={buttonBorderSx}>
        <ResetPageButton />
      </Box>
      <Box sx={buttonBorderSx}>
        <ResetDocumentButton />
      </Box>
      <Box sx={buttonBorderSx}>
        <UndoButton />
      </Box>
      <Box sx={buttonBorderSx}>
        <RedoButton />
      </Box>
      <Box sx={buttonBorderSx}>
        <PlaceObjectButton />
      </Box>
      <Box sx={buttonBorderSx}>
        <UploadObjectButton />
      </Box>
    </Box>
  );
}
